import React, { useEffect } from "react";
import { cubejsApi } from "../../../../Cubejs/CubejsApiWrapper";
import { geTagAllTimeMinMax } from "../service";



const OverViewGraphData = ({ selectTagData, setTagMinMaxValue,vmsTagSelect,overViewTagClickebleData }) => {
    // console.log("selectTagDataselectTagData", selectTagData);
    useEffect(() => {
        const fetchData = async () => {
            if (selectTagData.length) {
                // const minMaxvalue = await cubejsApi.load({
                //     "measures": [
                //         "DashboardTaghistoryreplica.minValue",
                //         "DashboardTaghistoryreplica.maxValue"
                //     ],
                //     "filters": [
                //         {
                //             "member": "DashboardTaghistoryreplica.latestTagName",
                //             "operator": "contains",
                //             "values": selectTagData.map((row) => row.tagName)
                //         }
                //     ],
                //     "dimensions": [
                //         "DashboardTaghistoryreplica.latestTagName"
                //     ]
                // });

                // if (minMaxvalue.tablePivot().length) {
                //     const arraySetData = minMaxvalue.tablePivot().map((row) => {
                //         return ({
                //             tagName: row["DashboardTaghistoryreplica.latestTagName"],
                //             minValue: row["DashboardTaghistoryreplica.minValue
                //             maxValue: row["DashboardTaghistoryreplica.maxValue"]
                //         })
                //     })
                //     console.log("arraySetData", arraySetData);
                //     setTagMinMaxValue(arraySetData)
                // }

                const param = {
                    tag_id: selectTagData.map((row) => row.tag_id)
                }
                try {
                    const resp = await geTagAllTimeMinMax(param);
                    if (resp.status == 200 || resp.status == 201 && resp.data.payload.length) {
                        console.log("resprespresp", resp.data.payload);
                        setTagMinMaxValue(resp.data.payload)
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        };

        // imidiatlty function call
        fetchData();


        const intervalId = setInterval(fetchData, 15000); // Call fetchData every 15 seconds

        return () => {
            clearInterval(intervalId); // Clear interval on component unmount
        };
    }, [vmsTagSelect]);
}

export default OverViewGraphData;